'use client';
import { Button, Image, VStack } from '@chakra-ui/react';
import { DrawerBody } from '@/components/ui';
import { useCartDrawer } from '@/contexts/cartDrawerContext';
import { useSafeRouter } from '@/hooks/route/useSafeRouter';

export const CartEmptyView = () => {
  const { onCartClose } = useCartDrawer();
  const { push } = useSafeRouter();

  return (
    <>
      <DrawerBody
        position="relative"
        padding="0"
        display="flex"
        overflowX="auto"
        paddingX="8px"
        alignItems="center"
        justifyContent="center"
        width="100%"
      >
        <VStack alignItems="center" justifyContent="center" gap={3}>
          <Image
            src="https://skin-seoul.com/wp-content/themes/hello-elementor-child/imgs/empty-cart.svg"
            alt="empty cart"
            width={200}
            height={200}
          />

          <Button
            onClick={() => {
              onCartClose();
              push('/');
            }}
            backgroundColor="neutral.400"
            borderRadius="8px"
            size="lg"
            textTransform="uppercase"
            width="100%"
          >
            Continue Shopping
          </Button>
        </VStack>
      </DrawerBody>
    </>
  );
};
